import leaderSeminar from '../views/leader-seminar/notice'

export default [
  {
    path: '/leader-seminar',
    name: 'leader-seminar',
    component: leaderSeminar
  },
]


// WEBPACK FOOTER //
// ./src/router/readership.js